import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { fullName } from '@pickem/shared';
import { Wordmark } from '../../components/Brand';
import { LeagueSwitcher } from '../../components/LeagueSwitcher';
import { useAuth } from '../../lib/auth';

export function AdminLayout() {
  const { user, logout, leagues, activeLeagueId } = useAuth();
  const navigate = useNavigate();
  const activeLeagueName = leagues.find((l) => l.id === activeLeagueId)?.name;

  const TABS = [
    { to: '/admin', label: 'Dashboard', end: true },
    { to: '/admin/weeks', label: 'Weeks' },
    { to: '/admin/scoring', label: 'Scoring' },
    ...(user?.isSuperAdmin ? [{ to: '/admin/users', label: 'Users' }] : []),
    { to: '/admin/staff', label: 'Staff' },
    ...(user?.isSuperAdmin ? [{ to: '/admin/leagues', label: 'Leagues' }] : []),
    { to: '/admin/audit', label: 'Audit Log' },
  ];

  return (
    <div className="min-h-full">
      <header className="bg-ink text-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
          <div className="flex items-center gap-3">
            <Wordmark showTag={false} />
            <span className="chip bg-amber/20 text-amber">Staff Admin</span>
            {activeLeagueName && (
              <span className="hidden text-sm text-white/70 sm:inline">{activeLeagueName}</span>
            )}
            <LeagueSwitcher />
          </div>
          <div className="flex items-center gap-4 text-sm text-white/80">
            <NavLink to="/" className="hover:text-white">
              ← Player view
            </NavLink>
            <span className="hidden sm:inline">{user ? fullName(user) : ''}</span>
            <button
              onClick={async () => {
                await logout();
                navigate('/login');
              }}
              className="hover:text-white"
            >
              Log out
            </button>
          </div>
        </div>
        <nav className="border-t border-white/10">
          <div className="mx-auto flex max-w-6xl gap-1 overflow-x-auto px-2">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                className={({ isActive }) =>
                  `whitespace-nowrap px-4 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? 'border-b-2 border-amber text-white'
                      : 'text-white/70 hover:text-white'
                  }`
                }
              >
                {t.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>
      <main key={activeLeagueId ?? 'none'} className="mx-auto max-w-6xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
